/**
 * Generative helpers for the Tapestry view — deterministic per-symbol seeded
 * randomness.
 *
 * Pure, no DOM. All randomness is seeded so scrubbing is reproducible.
 */

// ---------- Seeded PRNG ----------

/**
 * mulberry32 — small, fast, decent 32-bit PRNG. Returns a function that
 * yields floats in [0, 1).
 */
export function makeRng(seed) {
  let a = seed >>> 0;
  return function rng() {
    a = (a + 0x6d2b79f5) >>> 0;
    let t = a;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

/** Hash a string + integer to a 32-bit seed (FNV-1a variant). */
export function seedFor(name, salt = 0) {
  let h = 2166136261 ^ (salt >>> 0);
  for (let i = 0; i < name.length; i++) {
    h ^= name.charCodeAt(i);
    h = Math.imul(h, 16777619);
  }
  return h >>> 0;
}

/** Seeded random in [min, max). */
export function randRange(rng, min, max) {
  return min + rng() * (max - min);
}
